import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {FunctionBarSearchModel} from "../function-bar-search.model";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FunctionBarSearchPageComponent} from "../function-bar-search-page/function-bar-search-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FunctionBarSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-function-bar-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(FunctionBarSearchModel)
    ]
})
export class FunctionBarSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<FunctionBarSearchModel> {
    constructor(model: FunctionBarSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
        this.extendedSearchComponent = FunctionBarSearchPageComponent;
    }
}
